import { render, staticRenderFns } from "./backDataMultiDragBeforeNewTask.vue?vue&type=template&id=eb5ad630&scoped=true&"
import script from "./backDataMultiDragBeforeNewTask.vue?vue&type=script&lang=js&"
export * from "./backDataMultiDragBeforeNewTask.vue?vue&type=script&lang=js&"
import style0 from "./backDataMultiDragBeforeNewTask.vue?vue&type=style&index=0&id=eb5ad630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5ad630",
  null
  
)

export default component.exports